import { cn } from '@/lib/utils';
import Price from '../Price';

interface PropertyPriceProps {
  price: number;
  shouldShowHoverEffects: boolean;
}

export default function PropertyPrice({ price, shouldShowHoverEffects }: PropertyPriceProps) {
  return (
    <div
      className={cn(
        'flex items-center',
        'transition-all duration-300 ease-out',
        shouldShowHoverEffects ? 'scale-105' : 'scale-100'
      )}
    >
      <span className={cn('font-semibold transition-colors duration-200 text-base font-milligram')}>
        <Price price={price} className="text-xl  font-extrabold" />
        <span className="text-xs font-extrabold ">/ night</span>
      </span>
    </div>
  );
}
